import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ProfileService } from '../profile.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  errorMsg: string = null;
  dialogConfig = new MatDialogConfig();
  oldPasswordType: boolean;
  newPasswordType: boolean;
  confirmNewPasswordType: boolean;

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private profileService: ProfileService
  ) { }

  ngOnInit(): void {
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required]
    })
  }

  changePassword(f) {
    if (f.confirmNewPassword === f.newPassword) {
      const body = {
        OLD_PASSWORD: f.oldPassword,
        NEW_PASSWORD: f.newPassword
      }

      this.profileService.changePassword(body).subscribe(res => {
        this.dialogConfig.disableClose = true;
        this.dialogConfig.id = "modalConfirm";
        this.dialogConfig.width = '350px';

        this.dialogConfig.data = {
          title: "เปลี่ยนรหัสผ่านร้อยแล้ว",
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">เปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
          cancleBtnText: "ตกลง",
        }
        let confirmDialog = this.matDialog.open(ModalComponent, this.dialogConfig);
        confirmDialog.afterClosed().subscribe(() => {
          this.changePasswordForm.reset();
          this.errorMsg = null;
        })
      }, err => {
        this.errorMsg = err.error.message;
      })
    } else {
      this.errorMsg = 'รหัสผ่านใหม่ไม่ตรงกัน กรุณาลองใหม่อีกครั้ง'
    }
  }

  oldPasswordToggle() {
    this.oldPasswordType = !this.oldPasswordType
  }

  newPasswordToggle() {
    this.newPasswordType = !this.newPasswordType
  }

  confirmNewPasswordToggle() {
    this.confirmNewPasswordType = !this.confirmNewPasswordType
  }

}
